import { useFormatter } from "kw/util/useFormatter";
import { navigate } from "@reach/router";
import React, { FC } from "react";
import { Link } from "kanopi-components/Link";
import { SummaryTable } from "./SummaryTable";

type TAdminClaimSummarySection = {
  claim: TClaim;
};
export const AdminClaimSummarySection: FC<TAdminClaimSummarySection> = ({ claim }) => {
  const { formatDate, formatString } = useFormatter();
  const claimData = [
    {
      id: "policyNumber",
      label: "Policy number",
      value: (
        <Link
          title={claim?.policyNumber}
          to={`/admin/policies/${claim?.policyPeriods[0].policy?.id}`}
          onClick={() =>
            navigate(`/admin/policies/${claim?.policyPeriods[0].policy?.id}`)
          }
        >
          {formatString(claim?.policyNumber)}
        </Link>
      ),
    },
    {
      id: "policyType",
      label: "Policy type",
      value: formatString(claim?.claimProfile?.products?.[0]?.name),
    },
    {
      id: "name",
      label: "Customer",
      value: (
        <Link
          title={`${claim?.claimProfile?.owner?.firstName} ${claim?.claimProfile?.owner?.lastName}`}
          onClick={() => navigate(`/admin/customers/${claim?.claimProfile?.owner?.id}`)}
        >
          {formatString(
            `${claim?.claimProfile?.owner?.firstName} ${claim?.claimProfile?.owner?.lastName}`
          )}
        </Link>
      ),
    },
    {
      id: "created",
      label: "Claim date",
      value: formatDate(claim?.created),
    },
    {
      id: "decision",
      label: "Decision",
      value: formatString(claim?.decision),
    },
  ];

  return <SummaryTable data={claimData} type="CLAIM" />;
};
